module.exports = __webpack_public_path__ + "static/media/BG-site-em-construcao.95a220d2.jpg";